import {
    OperatorBlockItem,
    UserBlockItem,
} from '@/services/dtos/accessRequest.dto';
import { Ban, XCircle } from 'lucide-react';
import {
    ACCESS_SECTION_MESSAGES,
    BLOCK_REASON_LABEL,
} from './access-section-messages';

interface BlockedAccessSectionProps {
    users: UserBlockItem[];
    operators: OperatorBlockItem[];
}

export function BlockedAccessSection({
    users,
    operators,
}: BlockedAccessSectionProps) {
    return (
        <div className="space-y-4">
            <div className="flex items-center gap-2">
                <Ban className="h-5 w-5 text-red-600" />
                <h3 className="text-lg font-medium">
                    {ACCESS_SECTION_MESSAGES.BLOCKED.TITLE}
                </h3>
            </div>
            <div className="grid gap-2 text-sm">
                {users.length > 0 && (
                    <div className="flex items-center gap-1.5">
                        <XCircle className="h-4 w-4 text-red-700 shrink-0" />
                        <span>
                            <span className="font-medium text-red-700">
                                {ACCESS_SECTION_MESSAGES.BLOCKED.USERS_LABEL}
                            </span>
                            {users
                                .map(
                                    u =>
                                        `${u.w07usucod} (${BLOCK_REASON_LABEL[u.reason] ?? u.reason})`
                                )
                                .join(', ')}
                        </span>
                    </div>
                )}
                {operators.length > 0 && (
                    <div className="flex items-center gap-1.5">
                        <XCircle className="h-4 w-4 text-red-700 shrink-0" />
                        <span>
                            <span className="font-medium text-red-700">
                                {ACCESS_SECTION_MESSAGES.BLOCKED.OPERATORS_LABEL}
                            </span>
                            {operators
                                .map(
                                    o =>
                                        `${o.pair} (${BLOCK_REASON_LABEL[o.reason] ?? o.reason})`
                                )
                                .join(', ')}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
}
